import { LanguagesEffects } from './languages.effects';
import { SettingEffects } from './setting.effects';

export { LanguagesEffects, SettingEffects };

export const list = [LanguagesEffects, SettingEffects];
